import React, { useState, useEffect, useContext } from 'react';
import http from '../../services/http';
import { Grid, Modal, TextField, Typography } from '@mui/material';
import { ThemeContext } from '../ThemeContext/ThemeContext';
import DynamicField from '../DynamicField';

const FieldsManager = ({ field, updateField, setOpenFieldManager, ...props }) => {
    const { theme } = useContext(ThemeContext);
    const [fieldName, setFieldName] = useState(field.name);

    const handleToggleVisibility = async (field, checked) => {
        const updatedField = { ...field, visible: checked };
        updateField(updatedField);
    };
    return (
        <Grid
            sx={{
                bgcolor: theme.palette.primary.main, padding: '1.5rem 3rem 3rem 3rem', maxWidth: '600px',
                width: '100%', overflowY: 'auto', maxHeight: '50rem', borderRadius: '8px'
            }}
        >
            <Typography variant='h6' sx={{ marginBottom: '0.875rem' }}>
                Editar campo ({field.name})
            </Typography>
            <DynamicField key={field.name} field={field} updateField={updateField} editable={true} setOpenFieldManager={setOpenFieldManager}></DynamicField>
        </Grid>
    );
};

export default FieldsManager;
